import script from "./NewDatabaseInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDatabaseInfo.vue?vue&type=script&setup=true&lang=js"

import "./NewDatabaseInfo.vue?vue&type=style&index=0&id=4a2f11fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a2f11fa"]])

export default __exports__